module.exports = __webpack_public_path__ + "static/media/columns.42ec1a8e.svg";